<template lang="pug">
  div
    q-btn.q-mt-sm(flat='' color='gray-1' size='sm' label='Report user' @click='visible = true')
    q-dialog(v-model='visible' persistent)
      q-card(style='min-width: 550px')
        q-toolbar
          q-icon(name='report' size='md')
          q-toolbar-title Report User
        q-card-section.q-pt-none
          span.text-subtitle2 Please tell us why you want to report this user (*)
          q-input(v-model='description' placeholder='Enter description here' filled='' type='textarea')
        q-card-actions.text-primary(align='right')
          q-btn(flat='' label='Back' v-close-popup='')
          q-btn(color='primary' label='Submit' @click='report')
</template>

<script>
import API from '@/apis';
import { getErrorMessage } from '@/utils';

export default {
  name: 'Report',
  props: {
    user: {
      type: Object,
      default: () => console.error('[REPORT-USER] Missing user props on report modal.'),
    },
    itemId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      description: '',
    };
  },
  methods: {
    async report() {
      if (!this.description) {
        this.$q.notify({
          message: 'Please fill in the required field(s)',
          type: 'negative',
        });
        return;
      }

      try {
        const data = {
          userId: this.user.id,
          description: this.description,
          source: {
            path: this.$route.fullPath,
            name: this.$route.name,
            itemId: this.itemId,
          },
        };

        await this.$axios.request(API.report.create(data));
        this.description = '';
        this.visible = false;
        this.$q.notify({
          message: 'Report sent successfully',
          type: 'positive',
        });
      } catch (e) {
        this.$q.notify({
          message: getErrorMessage(e),
          type: 'negative',
        });
      }
    },
  },
};
</script>
